import { render, staticRenderFns } from "./MobileWidgetGrid.vue?vue&type=template&id=c74febe4&scoped=true&"
import script from "./MobileWidgetGrid.vue?vue&type=script&lang=ts&"
export * from "./MobileWidgetGrid.vue?vue&type=script&lang=ts&"
import style0 from "./MobileWidgetGrid.vue?vue&type=style&index=0&id=c74febe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74febe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBottomNavigation,VBtn,VContainer,VIcon,VSelect})
